import { InfoCircleOutlined } from "@ant-design/icons";
import { Flex } from "antd";
import { memo } from "react";

import { PrimaryText } from "@/shared/ui/Typography";

import {
    StyledActionsContainer,
    StyledCapturedImage,
    StyledTextButton,
    StyledViewContainer,
} from "../../Styled";
import { StyledWarningInfo } from "./Styled";

interface ForceCaptureConfirmModeProps {
    capturedImage: string;
    onRetake: () => void;
    onConfirm: () => void;
}

export const ForceCaptureConfirmMode = memo(
    ({ capturedImage, onRetake, onConfirm }: ForceCaptureConfirmModeProps) => (
        <>
            <StyledViewContainer>
                <StyledCapturedImage src={capturedImage} alt="Captured" />
            </StyledViewContainer>

            <StyledWarningInfo>
                <Flex gap={12} align="flex-start">
                    <InfoCircleOutlined />

                    <Flex vertical gap={4}>
                        <PrimaryText fontSize={16} textColor="white">
                            Увага! Фото зроблено з ігноруванням рекомендацій
                            щодо вирівнювання телефону.
                        </PrimaryText>

                        <PrimaryText fontSize={16} textColor="white">
                            Будь ласка, перевірте фото та підтвердьте своє
                            рішення.
                        </PrimaryText>
                    </Flex>
                </Flex>
            </StyledWarningInfo>

            <StyledActionsContainer justify="center" align="center" gap={16}>
                <StyledTextButton size="large" onClick={onRetake} type="text">
                    Скасувати
                </StyledTextButton>

                <StyledTextButton
                    size="large"
                    onClick={onConfirm}
                    type="primary"
                >
                    Підтвердити
                </StyledTextButton>
            </StyledActionsContainer>
        </>
    ),
);

ForceCaptureConfirmMode.displayName = "ForceCaptureConfirmMode";
